import { render, staticRenderFns } from "./combineBox.vue?vue&type=template&id=56f7804a&scoped=true"
import script from "./combineBox.vue?vue&type=script&lang=js"
export * from "./combineBox.vue?vue&type=script&lang=js"
import style0 from "./combineBox.vue?vue&type=style&index=0&id=56f7804a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7804a",
  null
  
)

export default component.exports